import { Wording } from '@/types';

export const MEDITATION_WORDING_FI: Wording = {
  components_header_media_content: 'Äänet',
  components_header_media_1: 'Meditaatiot',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Oppaat',
  components_header_text2: 'Blogi',
  components_header_members: 'jäsenet',
  hero_text: 'Missä meditaatio kohtaa tähdet',
  hero_button_text: 'Aloita matkasi sisäänpäin',
  components_ressources_section_title: 'RESURSSIT',
  components_ressources_subheader_text: 'Työkaluja sisäiseen rauhaan, maadoitukseen ja jokapäiväiseen tasapainoon',
  components_ressources_span_text: 'Avaa ovi sisäiseen rauhaan käsin valittujen meditaatioiden ja oppaiden avulla. Löydä selkeys, yhdistä hengityksesi ja harmonisoi sisäisen rytmiisi – yksi tietoinen hetki kerrallaan.',
  components_ressources_card_1_title: 'Heijastus',
  components_ressources_card_1_text: 'Lyhyet meditaatiot ja ääniheijastukset keskittääksesi ajatuksesi ja harmonisoidaksesi kosmisen rytmiisi.',
  components_ressources_card_2_title: 'Tutustu syvyyksiin',
  components_ressources_card_2_text: 'Matka pinnan taakse mukaansatempaavien oppaiden avulla, jotka yhdistävät meditaation, astrologian ja itsetutkinnan kestävää muutosta varten.',
  components_ressources_link: 'Katso lisää',
  components_notes_and_google_title_1: 'Sielullinen opastus',
  components_notes_and_google_title_2: 'Tietoiset rituaalit',
  components_notes_and_google_title_3: 'Ohjatut meditaatiot',
  components_review_google_text: 'Google-arvostelut',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Meidän meditaatiomme',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Tutustu lisää',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'OPPAAT',
  components_text1_subheader_text: 'Kosminen tieto päivittäiseen asettumiseen',
  components_text1_span_text: 'Yhdistä maailmankaikkeuden rytmeihin: tutustu syvällisten astrologisten ja meditatiivisten oppaiden kuratoituun kokoelmaan, joka on suunniteltu herättämään sisäistä selkeyttä, syventämään itsetietoisuutta ja tukemaan sielullisen, taivaallisen kasvun matkaasi.',
  components_text1_card_1_title: 'Avaa hiljaisuuteen',
  components_text1_card_1_text: 'Aloita matkasi perustavanlaatuisilla meditaatio- ja astrologiaoppailla – ihanteellinen etsijöille, joita vetää sisäinen hiljaisuus, kosmiset mallit ja henkilökohtainen oivallus.',
  components_text1_card_3_title: 'Mielen ja kehon linkki',
  components_text1_card_3_text: 'Paljasta sisäisen maailmasi syvemmät kerrokset. Nämä oppaat siirtyvät pinnan ulkopuolelle paljastaen merkityksen, tunteen ja tietoisia malleja, jotka muokkaavat kokemustasi.',
  components_text1_card_2_title: 'Heijastaa ja integroi',
  components_text1_card_2_text: 'Emotionaalisista lohkoista planetaarisiin sykleihin – nämä oppaat tarjoavat työkaluja pohdiskeluun, parantamiseen ja transformaatioon tietoisten rituaalien ja astrologisen viisauden avulla.',
  components_text1_link: 'Näytä kaikki oppaat',
  components_footer_text: 'Herää sisällä: hiljaisuutesi, voimasi',
  components_footer_info: 'Tiedot',
  components_footer_registration_number: 'Rekisterinumero',
  components_footer_legal: 'Laillinen',
  components_footer_terms: 'Ehdot',
  components_footer_privacy: 'Tietosuojakäytäntö',
  button_load_more: 'Lataa lisää',
  page_media_1_content_hero_text: 'Meditaatiot',
  page_media_content_menu_antistress: 'Antistressi',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energia Boost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Oppaat',
  page_text1_section_title: 'Oppaat',
  page_text1_subheader_text: 'Meidän oppaamme',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Anna sähköpostiosoitteesi jatkaaksesi',
  enter_email_placeholder_email: 'Sähköposti',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Kirjautuminen onnistui!',
  components_card_link_media_content: 'Kuuntele nyt',
  components_card_link_text1_content: 'Näytä opas',
  components_card_link_text2_content: 'Tutkia',
  france: 'Ranska',
  cyprus: 'Kypros',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditaatio',
  page_media_content_menu_all: 'Kaikki',
};